<template>
    <b-card>
        <div slot="header">&nbsp;{{ $t('label.generalInformation') }}</div>

        <b-form-group>
            <label>{{ $t('label.displayname') }}</label>
            <b-form-input
                :disabled="!canEdit"
                type="text"
                :placeholder="$t('label.displayname')"
                v-model="user.name"
            />
        </b-form-group>
        <b-form-group>
            <label>{{ $t('label.title') }}</label>
            <b-form-input
                :disabled="!canEdit"
                type="text"
                :placeholder="$t('label.title')"
                v-model="user.title"
            ></b-form-input>
        </b-form-group>
        <b-form-group>
            <label>{{ $t('label.firstname') }}</label>
            <b-form-input
                :disabled="!canEdit"
                type="text"
                :placeholder="$t('label.firstname')"
                v-model="user.firstname"
            ></b-form-input>
        </b-form-group>
        <b-form-group>
            <label>{{ $t('label.lastname') }}</label>
            <b-form-input
                :disabled="!canEdit"
                type="text"
                :placeholder="$t('label.lastname')"
                v-model="user.lastname"
            ></b-form-input>
        </b-form-group>

        <b-form-group v-if="!user.loading">
            <label>{{ $t('label.department') }}</label>
            <UnitDropdown
                @select="departmentChanged"
                :disabled="!canChangeUnit"
                :selectedUnitId="user.department_id"
            />
        </b-form-group>
        <b-form-group>
            <label>{{ $t('label.officephone') }}</label>
            <b-form-group>
                <PhoneNumberInput
                    v-model="user.office_phone"
                    :disabled="!canEdit"
                />
            </b-form-group>
        </b-form-group>

        <b-form-group>
            <label>{{ $t('label.mobilenumber') }}</label>
            <b-form-group>
                <PhoneNumberInput
                    :disabled="!canEdit || user.secureUser"
                    v-model="user.mobile_phone"
                />
            </b-form-group>
            <label class="text-muted" v-if="user.secureUser">
                Brukeren har sikker sone og endring av mobilnummer må skje via
                servicedesk
            </label>
        </b-form-group>
        <b-form-group v-if="canEdit && userMeta">
            <label>{{ $t('socialsecuritynumber') }}</label>
            <b-form-input
                type="text"
                placeholder
                v-model="userMeta.social_security_number"
            />
        </b-form-group>

        <div slot="footer">
            <!-- Save -->
            <b-button
                type="submit"
                v-if="canEdit"
                size="sm"
                variant="success"
                :disabled="!user.changed() || user.saving"
                @click="saveUser(user)"
            >
                <i class="fa fa-dot-circle-o" v-if="!user.saving"></i>
                <i class="fa fa-spinner fa-spin" v-if="user.saving"></i>
                {{ $t('label.save') }} </b-button
            >&nbsp;
            <!-- Cancel edit -->
            <b-button
                type="submit"
                size="sm"
                variant="danger"
                v-if="user.changed() && !user.saving"
                @click="user.cancelChanges()"
            >
                <i class="fa fa-dot-circle-o" v-if="!user.saving" />
                <i class="fa fa-spinner fa-spin" v-if="user.saving" />
                {{ $t('label.cancel') }} </b-button
            >&nbsp;
        </div>
    </b-card>
</template>

<script>
import UnitDropdown from '@/components/UnitDropdown'
import PhoneNumberInput from '@/components/Form/PhoneNumberInput'
import { mapGetters } from 'vuex'

export default {
    components: {
        UnitDropdown,
        PhoneNumberInput,
    },

    props: {
        userId: {
            required: true,
        },
        user: {
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: true,
            default: false,
        },
    },

    data() {
        return {
            loading: false,
            userMeta: this.user.meta,
        }
    },
    created() {
        this.user.on('change', () => {
            this.$forceUpdate()
        })
    },

    methods: {
        departmentChanged(department) {
            // console.log('Department changed!', department)
            this.user.department_id = department.id
        },
        saveUser(user) {
            user.save()
        },
    },

    watch: {},

    computed: {
        ...mapGetters({
            auth_user: 'auth/user',
        }),

        roleList() {
            return this.roles.filter(
                role => role.rank > this.auth_user.role.rank
            )
        },

        canChangeUnit() {
            // No user can move themself
            if (this.user.id == this.auth_user.id) {
                return false
            }

            return this.canEdit

            // // 'canEdit' is true when the user tries to edit him/herself
            // if(this.canEdit){

            //     // If the user is an employee we return false so that employees can't move themself
            //     if(this.auth_user.role.rank == 60){
            //         return false
            //     }

            //     // If not we return true
            //     return true
            // }

            // return false
        },
    },
}
</script>
